// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/physics.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/chemistry.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../images/zoology.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../images/botnay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../images/maths.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.physics_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chemistry_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.zoology_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.botnay_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.maths_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.asideNavBar {
  position: relative;
}
.asideNavBar .aside-content {
  position: fixed;
  height: 100%;
  width: 300px;
  right: -300px;
  top: 0;
  border: none;
  border-radius: 0;
  background: #ffffff;
  transition: left 500ms linear;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 9;
}
.asideNavBar .aside-content .card-title {
  cursor: pointer;
}
.asideNavBar.active .aside-content {
  right: 0;
}
.asideNavBar.active .overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: hsla(0, 0%, 100%, 0.1);
  z-index: 9;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.bookmarks_section .type-wise-list a {
  text-decoration: none;
  color: #212529;
}
.bookmarks_section .singlecard {
  height: 80px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  flex-direction: row;
  margin-bottom: 1rem;
  text-decoration: none;
}
.bookmarks_section .singlecard::before {
  background: hsla(0, 0%, 0%, 0.6);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
}
.bookmarks_section .singlecard .bg-img {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  filter: blur(2px);
}
.bookmarks_section .singlecard .content {
  color: #ffffff;
  position: relative;
  z-index: 2;
}
.bookmarks_section .singlecard .content .icon {
  text-align: center;
  display: block;
  line-height: 60px;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  color: #ffffff;
}
.bookmarks_section .singlecard .content .icon svg {
  height: 45px;
}
.bookmarks_section .tags-list {
  margin: 0;
  padding: 0;
}
.bookmarks_section .tags-list li {
  font-size: 13px;
  padding: 0.2rem 1rem;
  margin-bottom: 10px;
  border-radius: 30px;
  background: #e0e0e0;
}
.bookmarks_section .tags-list li a {
  color: #212529;
  text-decoration: none;
}

.bookmark-header {
  position: relative;
  padding: 25px 0 5px;
  color: #ffffff;
  background: #00a881;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.1607843137) !important;
}
.bookmark-header form.top_header .css-2b097c-container .css-26l3qy-menu {
  color: #212529;
}
.bookmark-header.chemistry {
  background: #0060ce;
}
.bookmark-header.physics {
  background: #feaf55;
}
.bookmark-header.botany {
  background: #3d8815;
}
.bookmark-header.zoology {
  background: #c37800;
}
.bookmark-header.maths {
  background: #707070;
}

.bookmarks_videos {
  position: relative;
}
.bookmarks_videos a {
  text-decoration: none;
  color: #212529;
}
.bookmarks_videos .card {
  overflow: hidden;
  border-radius: 6px;
}
.bookmarks_videos .card .bg-blur {
  background: hsla(0, 0%, 0%, 0.5) !important;
}
.bookmarks_videos .card .content {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.5);
  width: 100%;
  bottom: 0;
  left: 0;
}
.bookmarks_videos .card .content .card-title {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}
.bookmarks_videos .card .content .d-flex .videodurations {
  padding: 2px 4px;
  background: hsla(0, 0%, 0%, 0.4);
  border-radius: 6px 0;
}

.bookmark_shortNote_materials .bookmark_shortNotes_navs .nav-item .nav-link {
  color: #121412;
  font-weight: 400;
  padding: 0.5rem 1rem 1rem;
}
.bookmark_shortNote_materials .bookmark_shortNotes_navs .nav-item .nav-link.active {
  font-weight: 600;
  color: #007bff;
}
.bookmark_shortNote_materials .section-description .breadcrumb-content .breadcrumb {
  background: transparent !important;
}
.bookmark_shortNote_materials .shortnote_cards {
  margin: 0;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list {
  margin-bottom: 20px;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list:last-child {
  margin-bottom: 0;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list a {
  text-decoration: none;
  color: #121412;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .card-body {
  overflow: hidden;
  position: relative;
  height: 90px;
  margin-bottom: 15px;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card.fullView .card-body {
  height: 100%;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5098039216);
}
.bookmark_shortNote_materials .shortnote_cards .notesTags .card {
  cursor: pointer;
}
.bookmark_shortNote_materials .material_cards a {
  text-decoration: none;
  color: #121412;
}
.bookmark_shortNote_materials .material_cards .single_material_list {
  position: relative;
  margin-bottom: 20px;
}
.bookmark_shortNote_materials .material_cards .single_material_list:last-child {
  margin-bottom: 0;
}
.bookmark_shortNote_materials .material_cards .single_material_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5098039216);
}
.bookmark_shortNote_materials #filter-popover.popover {
  max-width: 300px !important;
}
@media (max-width: 991px) {
  .bookmark_shortNote_materials #filter-popover.popover .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .bookmark_shortNote_materials #filter-popover.popover .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .bookmark_shortNote_materials #filter-popover.popover .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body {
  padding: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs {
  background: #f8f9fa;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item {
  margin-bottom: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item .nav-link {
  border: none;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link {
  font-weight: 500;
  border: none;
  color: #495057;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link.active,
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  color: #121412;
  background-color: #f8f9fa;
  border-bottom: 2px solid #3ac555;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content {
  padding: 0.5rem 0.5rem 0;
  max-height: 130px;
  overflow-y: scroll;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li {
  margin-bottom: 6px;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li:not(:last-child) {
  margin-right: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li .text {
  width: 250px;
  line-height: 20px;
}

.practice_questions {
  position: relative;
}
.practice_questions .questions-list li {
  margin-bottom: 10px;
}
.practice_questions .questions-list li:last-child {
  margin-bottom: 0;
}
.practice_questions .questions-list li a {
  position: relative;
  text-decoration: none;
  color: #212529;
}
.practice_questions .questions-list li a .single_question {
  margin-right: 10px;
}
.practice_questions .questions-list li a:hover {
  background-color: #ffffff;
}
.practice_questions .questions-list li a.active .single_question {
  margin-right: 0px;
}
@media (max-width: 991px) {
  .practice_questions .questions-list li a.active .single_question {
    margin-right: 10px;
  }
}
.practice_questions .questions-list li .single_question .srNo {
  font-size: 14px;
  padding: 0.6rem;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dfdfdf;
  color: #3ac555;
  margin-right: 10px;
}
.practice_questions .questions-list li .single_question .question-content {
  height: 50px;
  overflow: hidden;
}
.practice_questions .note-list .card {
  cursor: pointer;
}

.page-indication .nav .nav-item {
  margin-right: 4px;
}
.page-indication .nav .nav-item:last-child {
  margin-right: 0;
}
.page-indication .nav .nav-item:nth-child(1) .nav-link.active {
  color: #ffffff;
  background: hsl(211, 100%, 50%);
  border: 1px solid hsla(211, 100%, 50%, 0.6);
}
.page-indication .nav .nav-item:nth-child(2) .nav-link.active {
  color: #ffffff;
  background: hsl(134, 61%, 41%);
  border: 1px solid hsla(134, 61%, 41%, 0.6);
}
.page-indication .nav .nav-item:nth-child(3) .nav-link.active {
  color: #ffffff;
  background: hsl(45, 100%, 51%);
  border: 1px solid hsla(45, 100%, 51%, 0.6);
}
.page-indication .nav .nav-item:nth-child(4) .nav-link.active {
  color: #ffffff;
  background: hsl(354, 70%, 54%);
  border: 1px solid hsla(354, 70%, 54%, 0.6);
}
.page-indication .nav .nav-item .nav-link {
  color: #121412;
  border-radius: 1.5rem;
  border: 1px solid #dfe0e1;
  padding: 0.5rem 1rem;
  transition: 0.3s all;
}

.sr-tags-list {
  position: relative;
}
.sr-tags-list li {
  font-size: 12px;
  padding: 0.1rem 1rem;
  margin-bottom: 10px;
  border-radius: 30px;
  background: #e0e0e0;
}
.sr-tags-list li:not(:last-child) {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/notes/_notes.scss"],"names":[],"mappings":"AAAA;EACE,yDAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,6CAAA;EACA,UAAA;AACJ;AACI;EACE,eAAA;AACN;AAGE;EACE,QAAA;AADJ;AAIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAFJ;;AAQI;EACE,qBAAA;EACA,cAAA;AALN;AASE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAPJ;AASI;EACE,gCAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAPN;AAUI;EACE,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;AARN;AAWI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AATN;AAWM;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;AAVR;AAYQ;EACE,YAAA;AAVV;AAgBE;EACE,SAAA;EACA,UAAA;AAdJ;AAgBI;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAdN;AAgBM;EACE,cAAA;EACA,qBAAA;AAdR;;AAoBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,+DAAA;AAjBF;AAoBI;EACE,cAAA;AAlBN;AAsBE;EACE,mBAAA;AApBJ;AAuBE;EACE,mBAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;AAvBJ;AA0BE;EACE,mBAAA;AAxBJ;;AA4BA;EACE,kBAAA;AAzBF;AA2BE;EACE,qBAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,2CAAA;AA1BN;AA6BI;EACE,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AA3BN;AA6BM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA3BR;AA8BM;EACE,gBAAA;EACA,gCAAA;EACA,oBAAA;AA5BR;;AAoCI;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;AAjCN;AAmCM;EACE,gBAAA;EACA,cAAA;AAjCR;AA0CM;EACE,kCAAA;AAxCR;AA6CE;EACE,SAAA;AA3CJ;AA6CI;EACE,mBAAA;AA3CN;AA6CM;EACE,gBAAA;AA3CR;AA8CM;EACE,qBAAA;EACA,cAAA;AA5CR;AAgDQ;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AA9CV;AAkDU;EACE,YAAA;AAhDZ;AAoDQ;EACE,eAAA;EACA,kCAAA;AAlDV;AAuDI;EACE,eAAA;AArDN;AA0DI;EACE,qBAAA;EACA,cAAA;AAxDN;AA2DI;EACE,kBAAA;EACA,mBAAA;AAzDN;AA2DM;EACE,gBAAA;AAzDR;AA6DQ;EACE,eAAA;EACA,kCAAA;AA3DV;AAiEE;EACE,2BAAA;AA/DJ;AAiEI;EACE;IACE,sDAAA;EA/DN;AACF;AAkEI;EACE;IACE,aAAA;IACA,sBAAA;EAhEN;EAkEM;IACE,uBAAA;IACA,mBAAA;EAhER;AACF;AAoEI;EACE,UAAA;AAlEN;AAoEM;EACE,mBAAA;EACA,+BAAA;EACA,gCAAA;AAlER;AAqEM;EACE,gBAAA;AAnER;AAqEQ;EACE,YAAA;AAnEV;AAuEM;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AArER;AAwEM;;EAEE,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;AAtER;AAyEM;EACE,wBAAA;EACA,iBAAA;EACA,kBAAA;AAvER;AAyEQ;EACE,kBAAA;AAvEV;AAyEU;EACE,eAAA;AAvEZ;AA0EU;EACE,YAAA;EACA,iBAAA;AAxEZ;;AAgFA;EACE,kBAAA;AA7EF;AA+EE;EACE,mBAAA;AA7EJ;AA+EI;EACE,gBAAA;AA7EN;AAgFI;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;AA9EN;AAgFM;EACE,kBAAA;AA9ER;AAiFM;EACE,yBAAA;AA/ER;AAmFQ;EACE,iBAAA;AAjFV;AAqFM;EAEI;IACE,kBAAA;EApFV;AACF;AA0FM;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAxFR;AA2FM;EACE,YAAA;EACA,gBAAA;AAzFR;AA8FE;EACE,eAAA;AA5FJ;;AAiGE;EACE,iBAAA;AA9FJ;AAgGI;EACE,eAAA;AA9FN;AAiGI;EACE,cAAA;EACA,+BAAA;EACA,2CAAA;AA/FN;AAkGI;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAhGN;AAmGI;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAjGN;AAoGI;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAlGN;AAqGI;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,oBAAA;AAnGN;;AAwGA;EACE,kBAAA;AArGF;AAsGG;EACC,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AApGJ;AAqGI;EACE,oBAAA;AAnGN","sourcesContent":[".physics_img {\n  background-image: url(\"../../../images/physics.png\");\n}\n\n.chemistry_img {\n  background-image: url(\"../../../images/chemistry.png\");\n}\n\n.zoology_img {\n  background: url(\"../../../images/zoology.png\");\n}\n\n.botnay_img {\n  background: url(\"../../../images/botnay.png\");\n}\n\n.maths_img {\n  background: url(\"../../../images/maths.png\");\n}\n\n.asideNavBar {\n  position: relative;\n\n  .aside-content {\n    position: fixed;\n    height: 100%;\n    width: 300px;\n    right: -300px;\n    top: 0;\n    border: none;\n    border-radius: 0;\n    background: #ffffff;\n    transition: left 500ms linear;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    z-index: 9;\n\n    .card-title {\n      cursor: pointer;\n    }\n  }\n\n  &.active .aside-content {\n    right: 0;\n  }\n\n  &.active .overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-color: hsla(0, 0%, 100%, 0.1);\n    z-index: 9;\n    cursor: pointer;\n    user-select: none;\n  }\n}\n\n.bookmarks_section {\n  .type-wise-list {\n    a {\n      text-decoration: none;\n      color: #212529;\n    }\n  }\n\n  .singlecard {\n    height: 80px;\n    position: relative;\n    border-radius: 6px;\n    overflow: hidden;\n    flex-direction: row;\n    margin-bottom: 1rem;\n    text-decoration: none;\n\n    &::before {\n      background: hsla(0, 0%, 0%, 0.6);\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      content: \"\";\n      position: absolute;\n      z-index: 1;\n    }\n\n    .bg-img {\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      content: \"\";\n      position: absolute;\n      z-index: 1;\n      background-size: cover;\n      background-position: top center;\n      background-repeat: no-repeat;\n      filter: blur(2px);\n    }\n\n    .content {\n      color: #ffffff;\n      position: relative;\n      z-index: 2;\n\n      .icon {\n        text-align: center;\n        display: block;\n        line-height: 60px;\n        width: 60px;\n        height: 60px;\n        border-radius: 4px;\n        // background: hsla(0, 0%, 0%, 0.7);\n        color: #ffffff;\n\n        svg {\n          height: 45px;\n        }\n      }\n    }\n  }\n  \n  .tags-list {\n    margin: 0;\n    padding: 0;\n\n    li {\n      font-size: 13px;\n      padding: 0.2rem 1rem;\n      margin-bottom: 10px;\n      border-radius: 30px;\n      background: #e0e0e0;\n\n      a {\n        color: #212529;\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n.bookmark-header {\n  position: relative;\n  padding: 25px 0 5px;\n  color: #ffffff;\n  background: #00a881;\n  box-shadow: 0px 3px 16px #00000029 !important;\n\n  form.top_header .css-2b097c-container {\n    .css-26l3qy-menu {\n      color: #212529;\n    }\n  }\n\n  &.chemistry {\n    background: #0060ce;\n  }\n\n  &.physics {\n    background: #feaf55;\n  }\n\n  &.botany {\n    background: #3d8815;\n  }\n\n  &.zoology {\n    background: #c37800;\n  }\n\n  &.maths {\n    background: #707070;\n  }\n}\n\n.bookmarks_videos {\n  position: relative;\n\n  a {\n    text-decoration: none;\n    color: #212529;\n  }\n\n  .card {\n    overflow: hidden;\n    border-radius: 6px;\n\n    .bg-blur {\n      background: hsla(0, 0%, 0%, 0.5) !important;\n    }\n\n    .content {\n      position: absolute;\n      background: hsla(0, 0%, 100%, 0.5);\n      width: 100%;\n      bottom: 0;\n      left: 0;\n\n      .card-title {\n        font-size: 15px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin-bottom: 0;\n      }\n\n      .d-flex .videodurations {\n        padding: 2px 4px;\n        background: hsla(0, 0%, 0%, 0.4);\n        border-radius: 6px 0;\n      }\n    }\n  }\n}\n\n.bookmark_shortNote_materials {\n  .bookmark_shortNotes_navs {\n    .nav-item .nav-link {\n      color: #121412;\n      font-weight: 400;\n      padding: 0.5rem 1rem 1rem;\n\n      &.active {\n        font-weight: 600;\n        color: #007bff;\n      }\n    }\n  }\n\n  .section-description {\n    // background-color: #e9ecef;\n\n    .breadcrumb-content {\n      .breadcrumb {\n        background: transparent !important;\n      }\n    }\n  }\n\n  .shortnote_cards {\n    margin: 0;\n\n    li.single_shortnote_list {\n      margin-bottom: 20px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      a {\n        text-decoration: none;\n        color: #121412;\n      }\n\n      .single_card {\n        .card-body {\n          overflow: hidden;\n          position: relative;\n          height: 90px;\n          margin-bottom: 15px;\n        }\n\n        &.fullView {\n          .card-body {\n            height: 100%;\n          }\n        }\n\n        .helpTags li.list-inline-item {\n          cursor: pointer;\n          color: #00000082;\n        }\n      }\n    }\n\n    .notesTags .card {\n      cursor: pointer;\n    }\n  }\n\n  .material_cards {\n    a {\n      text-decoration: none;\n      color: #121412;\n    }\n\n    .single_material_list {\n      position: relative;\n      margin-bottom: 20px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      .single_card {\n        .helpTags li.list-inline-item {\n          cursor: pointer;\n          color: #00000082;\n        }\n      }\n    }\n  }\n\n  #filter-popover.popover {\n    max-width: 300px !important;\n\n    @media (max-width: 991px) {\n      .card-group .card + .card {\n        border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n      }\n    }\n\n    @media (max-width: 991px) {\n      .card-group {\n        display: flex;\n        flex-flow: column wrap;\n\n        .card {\n          flex-direction: inherit;\n          margin-bottom: 15px;\n        }\n      }\n    }\n\n    .popover-body {\n      padding: 0;\n\n      .nav-tabs {\n        background: #f8f9fa;\n        border-top-left-radius: 0.25rem;\n        border-top-right-radius: 0.25rem;\n      }\n\n      .nav-tabs .nav-item {\n        margin-bottom: 0;\n\n        .nav-link {\n          border: none;\n        }\n      }\n\n      .nav-tabs .nav-link {\n        font-weight: 500;\n        border: none;\n        color: #495057;\n      }\n\n      .nav-tabs .nav-link.active,\n      .nav-tabs .nav-item.show .nav-link {\n        font-weight: 600;\n        color: #121412;\n        background-color: #f8f9fa;\n        border-bottom: 2px solid #3ac555;\n      }\n\n      .tab-content {\n        padding: 0.5rem 0.5rem 0;\n        max-height: 130px;\n        overflow-y: scroll;\n\n        .custom-list li {\n          margin-bottom: 6px;\n\n          &:not(:last-child) {\n            margin-right: 0;\n          }\n\n          .text {\n            width: 250px;\n            line-height: 20px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.practice_questions {\n  position: relative;\n\n  .questions-list li {\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    a {\n      position: relative;\n      text-decoration: none;\n      color: #212529;\n\n      .single_question {\n        margin-right: 10px;\n      }\n\n      &:hover {\n        background-color: #ffffff;\n      }\n\n      &.active {\n        .single_question {\n          margin-right: 0px;\n        }\n      }\n\n      @media (max-width: 991px) {\n        &.active {\n          .single_question {\n            margin-right: 10px;\n          }\n        }\n      }\n    }\n\n    .single_question {\n      .srNo {\n        font-size: 14px;\n        padding: 0.6rem;\n        border-radius: 4px;\n        text-align: center;\n        border: 1px solid #dfdfdf;\n        color: #3ac555;\n        margin-right: 10px;\n      }\n\n      .question-content {\n        height: 50px;\n        overflow: hidden;\n      }\n    }\n  }\n\n  .note-list .card {\n    cursor: pointer;\n  }\n}\n\n.page-indication {\n  .nav .nav-item {\n    margin-right: 4px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:nth-child(1) .nav-link.active {\n      color: #ffffff;\n      background: hsla(211, 100%, 50%, 1);\n      border: 1px solid hsla(211, 100%, 50%, 0.6);\n    }\n\n    &:nth-child(2) .nav-link.active {\n      color: #ffffff;\n      background: hsla(134, 61%, 41%, 1);\n      border: 1px solid hsla(134, 61%, 41%, 0.6);\n    }\n\n    &:nth-child(3) .nav-link.active {\n      color: #ffffff;\n      background: hsla(45, 100%, 51%, 1);\n      border: 1px solid hsla(45, 100%, 51%, 0.6);\n    }\n\n    &:nth-child(4) .nav-link.active {\n      color: #ffffff;\n      background: hsla(354, 70%, 54%, 1);\n      border: 1px solid hsla(354, 70%, 54%, 0.6);\n    }\n\n    .nav-link {\n      color: #121412;\n      border-radius: 1.5rem;\n      border: 1px solid #dfe0e1;\n      padding: 0.5rem 1rem;\n      transition: 0.3s all;\n    }\n  }\n}\n\n.sr-tags-list {\n  position: relative;\n   li {\n    font-size: 12px;\n    padding: 0.1rem 1rem;\n    margin-bottom: 10px;\n    border-radius: 30px;\n    background: #e0e0e0;\n    &:not(:last-child) {\n      margin-right: 0.5rem;\n  }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
